import { DateTime } from "luxon";

import {
  DISPLAY_DATE_FORMAT,
  DISPLAY_DATE_FORMAT_WITH_TIME,
} from "./dateFormatter";

export default function getDateString(date: string) {
  if (date) {
    return DateTime.fromISO(date, { setZone: true }).toFormat(
      DISPLAY_DATE_FORMAT
    );
  }
  return "";
}

export function getDateAndTimeString(date: string) {
  if (date) {
    return (
      DateTime.fromISO(date, { setZone: true }).toFormat(
        DISPLAY_DATE_FORMAT_WITH_TIME
      ) + " EST"
    );
  }
  return "";
}
